import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type CurrencyConversionOrganizationContext from 'lumen/models/currency-conversion/organization-context';
import ApplicationSerializer from 'lumen/serializers/application';

export default class CurrencyConversionOrganizationContextSerializer extends ApplicationSerializer {
  primaryKey = 'organization_id';

  modelNameFromPayloadKey(key: string): string {
    if (key === 'organization_context') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey(
        'currency-conversion/organization-context',
      );
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  payloadKeyFromModelName(): string {
    return 'organization_context';
  }

  serialize(
    snapshot: Snapshot<CurrencyConversionOrganizationContext>,
  ): Record<string, unknown> {
    return {
      default_currency: snapshot.record?.defaultCurrency ?? null,
    };
  }
}
